import type { ListEquipmentAssignmentRulesMatrixInput } from '@/lib/api/orpc/contracts/equipment-assignment-rule';
export type AssignmentMatrixInput = ListEquipmentAssignmentRulesMatrixInput;
export type AssignmentMatrixOrderBy = NonNullable<AssignmentMatrixInput['orderBy']>;
export const ASSIGNMENT_MATRIX_FIELD_KEYS = ['EquipmentListItem', 'EquipmentAssignmentRulePeopleGroup', 'EquipmentAssignmentRuleIndividualInclude', 'EquipmentAssignmentRuleIndividualExclude'] as const;
export type AssignmentMatrixFieldKey = (typeof ASSIGNMENT_MATRIX_FIELD_KEYS)[number];
export const ASSIGNMENT_MATRIX_ORDER_BY = {
  ITEM_NAME: 'ITEM_NAME',
  PEOPLE_GROUP_NAME: 'PEOPLE_GROUP_NAME'
} as const satisfies Record<string, AssignmentMatrixOrderBy>;